import { TextField } from "@material-ui/core";
import Drawer from "../../../../../components/Drawer";
import CategoryInput from "../Drawer/CategoryInput";
import PriceInput from "../../../../../components/inputs/PriceInput";
import Spinner from "react-bootstrap/Spinner";
import VariationInput from "../Drawer/VariationInput";
import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";

const AddFashionDrawer = ({
  erroName,
  erroCategory,
  erroPrice,
  erroMessage,
  loadBtn,
  isFashionDrawerOpen,
  setOpenDrawer,
  product,
  handleProductChange,
  handleSubmitFashionProduct,
  subCategories,
  isAddSubCategoryLoading,
  selectedImage,
  selectImage,
  handleAddSubCategory,
  variations,
  getVariations,
  loadBtnPhoto,
  setImageDelete,
}) => {
  const [tagsVariations, setTagsVariations] = useState([]);
  // const [variationTagState, setVariationTagState] = useState([]);

  const getVariationTagState = () => {
    if (isFashionDrawerOpen) {
      let variationProduct = [...product.productVariations];
      let variationState = [...variations];
      // console.log(variationProduct.length);
      // console.log(variationState.length);
      for (let i = 0; i < variationProduct.length; i++) {
        let tag = variationProduct[i];
        for (let j = 0; j < variationState.length; j++) {
          let stateTag = variationState[j];
          if (tag.title === stateTag.title) {
            variationState.forEach(() => {
              variationProduct.splice(i, 1);
            });
          }
        }
      }
      let variation = [...variationProduct, ...variationState];
      return variation;
    }
  };

  const variationTagState = getVariationTagState();

  const getVariationTags = (variationTitle, tags) => {
    let variationState = tagsVariations;
    let variation = {};
    let variations = [];
    variation.title = variationTitle;
    tags.map((tag) => {
      variations.push({ name: tag });
    });
    variation.variations = variations;

    let index = variationState.findIndex((val) => val.title === variation.title);
    if (index < 0) {
      variationState.push(variation);
    } else {
      variationState.map((variation, index) => {
        if (variation.title === variationTitle) {
          variationState.splice(index, 1);
        }
      });
      variationState.push(variation);
    }

    setTagsVariations([...variationState]);
    getVariations([...variationState]);
  };

  useEffect(() => {}, []);
  return (
    <>
      <Drawer show={isFashionDrawerOpen} onClose={() => setOpenDrawer(false)}>
        <form style={{ maxHeight: "100%" }}>
          <div className="d-flex flex-column">
            <span className="text-cl-black ff-univanova-medium fz-20 mb-3 d-block">Foto do produto (opcional) </span>
            <form>
              <div className="d-flex flex-wrap m-0 mb-5">
                {product.productPhoto !== undefined ? (
                  <>
                    {product.productPhoto.map((item, index) => (
                      <div
                        data-bs-toggle="modal"
                        data-bs-target={"#confirmDeleteImage"}
                        key={index}
                        onClick={() => setImageDelete([index, item._id])}
                        className={`d-flex c-pointer m-2 `}
                      >
                        <img src={item.url} className=" img-fluid" alt="" style={{ height: "137px" }} />
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}
                {!selectedImage.length ? (
                  <></>
                ) : (
                  <>
                    {selectedImage?.map((image, index) => (
                      <div
                        data-bs-toggle="modal"
                        data-bs-target={"#confirmDeleteImage"}
                        key={index}
                        onClick={() => setImageDelete([index])}
                        className={`d-flex c-pointer m-2 `}
                      >
                        <img src={image} className=" img-fluid" alt="" style={{ height: "137px" }} />
                      </div>
                    ))}
                  </>
                )}
                <label
                  htmlFor="file"
                  className={` bg-cl-chinese-white d-flex m-2  justify-content-center align-items-center flex-column c-pointer `}
                  style={{ height: "137px", width: "187px" }}
                >
                  {loadBtnPhoto ? (
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : (
                    <>
                      <i className="bi bi-plus-circle fz-26 fa-lg text-cl-light-blue-steel"></i>
                      <span className="text-cl-philippine-silver ff-univanova-medium fz-16">Adicionar foto</span>
                    </>
                  )}
                  <input type="file" id="file" onChange={selectImage} className="d-none" required />
                </label>
              </div>
            </form>

            <span className="text-cl-black ff-univanova-medium fz-20 mb-4 d-block">Informações gerais</span>
            <TextField
              onChange={(event) => handleProductChange(event)}
              value={product.name}
              required
              name="name"
              label={"Nome do produto"}
              variant={"outlined"}
              // style={{ width: "70%" }}
              error={erroName}
              className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
            />
            <CategoryInput
              {...{
                erroCategory,
                handleProductChange,
                handleAddSubCategory,
                isAddSubCategoryLoading,
                product,
                subCategories,
              }}
            />
            {variationTagState ? (
              <>
                {variationTagState.map((variation, index) => (
                  <VariationInput
                    product={product}
                    index={index}
                    // variations={variation}
                    name={variation.title}
                    variationTitle={variation.title}
                    variationTags={variation.variations}
                    getVariationTags={getVariationTags}
                  />
                ))}
              </>
            ) : (
              <></>
            )}
            <TextField
              onChange={(event) => handleProductChange(event)}
              value={product.description}
              name="description"
              label={"Descrição (opcional)"}
              variant={"outlined"}
              className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
              multiline
              // style={{ width: "80%" }}
              minRows={4}
            />
            <TextField
              onChange={(event) => handleProductChange(event)}
              value={product.sku}
              name="sku"
              label={"SKU (opcional)"}
              variant={"outlined"}
              className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
              // style={{ width: "70%" }}
            />
            <TextField
              onChange={(event) => handleProductChange(event)}
              value={product.qty}
              name="qty"
              label={"Quantidade (opcional)"}
              variant={"outlined"}
              className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
              // style={{ width: "38%" }}
            />

            <PriceInput
              error={erroPrice}
              input={product}
              label="Preço *"
              onValueChange={(values) => {
                const { floatValue } = values;
                // do something with floatValue
                handleProductChange({
                  target: { name: "price", value: floatValue },
                });
              }}
            />

            {/* <TextField
              onChange={(event) => handleProductChange(event)}
              value={product.discount}
              name="discount"
              label={"Desconto (opcional)"}
              variant={"outlined"}
              className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
              // style={{ width: "70%" }}
            /> */}

            <p style={{ color: "red" }}>{erroMessage}</p>
          </div>
          <div className={`col-12 col-lg d-flex justify-content-end `}>
            <button
              onClick={(e) => setOpenDrawer(false)}
              className="bg-transparent border-1 me-4 rounded-2 fz-16 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-4 botton-cancel"
            >
              Cancelar
            </button>

            {loadBtn ? (
              <div className="btn br-6 bg-gradient-theme-blue text-white px-4 d-flex align-items-center justify-content-center">
                <Spinner animation="border" role="status" style={{ height: 20, width: 20 }} className="mx-2" />
              </div>
            ) : (
              <button
                disabled={loadBtn}
                onClick={(e) => handleSubmitFashionProduct(e)}
                className="btn br-6 bg-gradient-theme-blue text-white px-4"
              >
                Salvar
              </button>
            )}
          </div>
        </form>
      </Drawer>
    </>
  );
};

export default AddFashionDrawer;
